import { render, staticRenderFns } from "./NewYagiofferEdit.vue?vue&type=template&id=6a8dadb1&scoped=true"
import script from "./NewYagiofferEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewYagiofferEdit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NewYagiofferEdit.vue?vue&type=style&index=0&id=6a8dadb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8dadb1",
  null
  
)

export default component.exports